import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import { LookupAlumnoCarrera } from '../AlumnoCarrera/LookupAlumnoCarrera';
import { LookupCursadas } from '../Cursadas/LookupCursadas';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as inscripcionesService from '../../services/inscripciones/inscripcionesService';
import {
  classifyInscripcionesError,
  toInscripcionCursadaMultiplePayload,
  validateInscripcionCursadaMultipleForm,
} from '../../services/inscripciones/inscripcionesDto';
import { MdPageErrorMessage } from '../common/mdPageErrorMessage';

function parseLookupCursadaValue(value) {
  const parts = value.split('%');
  return {
    cursadaCod: parts[0] || '',
    materiaNombre: (parts[1] || '').trim(),
    carreraNombre: (parts[2] || '').trim(),
    periodoDescripcion: (parts[4] || '').trim(),
    materiaCarreraCod: (parts[5] || '').trim(),
  };
}

function formatCursadaInscripcionDisplay(cursada) {
  return [
    cursada.materiaNombre,
    cursada.carreraNombre,
    cursada.periodoDescripcion,
  ].filter(Boolean).join(' - ');
}

export class AddInscripcionCursada extends Component {
  static displayName = AddInscripcionCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      showLookupAnios: false,
      showCursada: false,
      alumno: { codigo: '', descripcion: '' },
      cursadas: [],
      carreraCursada: -1,
      ignorarCorrelatividad: false,
    };
  }

  handleConfirmButton = () => {
    const alumnoId = parseInt(this.state.alumno.codigo, 10) || 0;
    if (!validateInscripcionCursadaMultipleForm({
      alumnoId,
      cursadaCount: this.state.cursadas.length,
    })) {
      this.setState({ showErrorMessage: true, errorMessage: 'Todos los campos son obligatorios' });
      return;
    }
    this.saveStudent();
  };

  async componentDidMount() {
    await constantClass.canAccess('WWInscripcionCursada');
  }

  handleRemoveCursada = (id) => {
    this.setState({
      cursadas: this.state.cursadas.filter((cursada) => cursada.id !== id),
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleShowAniosLookup = () => {
    this.setState({ showLookupAnios: true });
  };

  handleShowCursadaLookup = () => {
    this.setState({ showCursada: true });
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleHideLookupCursada = () => {
    this.setState({ showCursada: false });
  };

  handleSelectAnioItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupAnios: false,
      showErrorMessage: false,
      errorMessage: '',
      carreraCursada: Number(carreraProperties[3]),
      cursadas: [],
      alumno: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1] + ' - ' + carreraProperties[2],
      },
    });
  };

  handleCheckBox = (e) => {
    this.setState({ ignorarCorrelatividad: e.target.checked });
  };

  handleSelectCursadaItem = (e) => {
    const cursada = parseLookupCursadaValue(e);
    if (this.state.cursadas.some((item) => item.id === cursada.cursadaCod)) {
      this.setState({ showCursada: false });
      return;
    }
    if (this.state.cursadas.some((item) => item.materiaCarreraCod === cursada.materiaCarreraCod)) {
      this.setState({
        showCursada: false,
        showErrorMessage: true,
        errorMessage: 'Ya existe una inscripción para la misma materia.',
      });
      return;
    }
    this.setState({
      showCursada: false,
      showErrorMessage: false,
      errorMessage: '',
      cursadas: this.state.cursadas.concat({
        id: cursada.cursadaCod,
        text: formatCursadaInscripcionDisplay(cursada),
        materiaCarreraCod: cursada.materiaCarreraCod,
      }),
    });
  };

  renderCursadaList() {
    if (!this.state.cursadas.length) {
      return null;
    }
    return (
      <ul className="md-page__tag-list">
        {this.state.cursadas.map((cursada) => (
          <li key={cursada.id} className="md-page__tag">
            <span>{cursada.text}</span>
            {!this.state.loading ? (
              <button
                type="button"
                className="md-page__tag-remove"
                aria-label={'Quitar cursada ' + cursada.text}
                onClick={() => this.handleRemoveCursada(cursada.id)}
              >
                ×
              </button>
            ) : null}
          </li>
        ))}
      </ul>
    );
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-ic" />;
    }

    const { loading } = this.state;
    const alumnoDisplay = this.state.alumno.descripcion.trim();
    const canSelectCursada = !loading && this.state.carreraCursada !== -1;

    return (
      <div className="md-page md-add-inscripcion-cursada">
        <Link className="md-page__back-link" to="/md-ic">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nueva Inscripción a Cursada</h1>
          <p className="md-page__subtitle">
            Seleccione el alumno y una o más cursadas para registrar las inscripciones.
          </p>
        </div>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <MdPageErrorMessage message={this.state.errorMessage} />
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Alumno</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowAniosLookup}>
                  Seleccione el Alumno
                </button>
              ) : null}
              <div className="md-page__field-readonly">{alumnoDisplay}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Cursadas</span>
            <div className="md-page__picker-block">
              {canSelectCursada ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCursadaLookup}>
                  Seleccione la Cursada
                </button>
              ) : (
                <p className="md-page__file-hint">Seleccione un alumno antes de elegir las cursadas.</p>
              )}
              {this.renderCursadaList()}
            </div>
          </div>

          <div className="md-add-inscripcion-examen__options">
            <label className="md-add-inscripcion-examen__option">
              <input
                type="checkbox"
                checked={this.state.ignorarCorrelatividad}
                onChange={this.handleCheckBox}
                disabled={loading}
              />
              {' '}Ignorar verificación de correlatividad
            </label>
          </div>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Confirmar
            </button>
          </div>
        </div>

        {this.state.showLookupAnios ? (
          <LookupAlumnoCarrera selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
        ) : null}
        {this.state.showCursada ? (
          <LookupCursadas
            carreraCod={this.state.carreraCursada}
            selectItem={this.handleSelectCursadaItem}
            hideLookup={this.handleHideLookupCursada}
          />
        ) : null}
      </div>
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    const cursadas = this.state.cursadas.map((cursada) => ({
      cursada: parseInt(cursada.id, 10),
      materiaCarreraCod: cursada.materiaCarreraCod,
    }));
    try {
      await inscripcionesService.saveInscripcionesCursadaMultiple(toInscripcionCursadaMultiplePayload({
        alumnoxCarreraCod: parseInt(this.state.alumno.codigo, 10),
        ignorarCorrelatividad: this.state.ignorarCorrelatividad,
        cursadas,
      }));
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyInscripcionesError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
